import HTTP from '.';
import ContactUsServiceMock from './mocks/ContactUsService.mock';
import config from '@/config';

export default class ContactUsService {
  static getOfficesInformation() {
    if (config.ENV.MOCK === true) {
      return ContactUsServiceMock.getOfficesInformation();
    }

    return HTTP.get('/api/offices/contactinformations');
  }

  static getExternalDirectory() {
    if (config.ENV.MOCK === true) {
      return ContactUsServiceMock.getExternalDirectory();
    }

    return HTTP.get('/api/external-directory/organizations');
  }

  static getOfficeDirectory() {
    if (config.ENV.MOCK === true) {
      return ContactUsServiceMock.getExternalDirectory();
    }

    return HTTP.get('/api/offices');
  }

  static getOfficeRepresentatives(officeId) {
    if (config.ENV.MOCK === true) {
      return ContactUsServiceMock.getOfficeRepresentatives();
    }

    return HTTP.get(`/api/offices/${officeId}/representatives/`);
  }
}
